import { faQrcode } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { SmartLink } from '../organisms/SmartLink';

export type IAppToolsSmartLinkPagProps = {
  appId: string;
};

export const AppToolsSmartLinkPage: React.FC<IAppToolsSmartLinkPagProps> = (
  props,
) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppToolsSmartLinkPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faQrcode} />}
        title={t('AppToolsSmartLinkPage.title')}
        subtitle={t('AppToolsSmartLinkPage.subtitle')}
      />

      <SmartLink appId={appId} />
    </>
  );
};
